import React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import { Spinner, Row, Col, Card } from "react-bootstrap";
import HSAxios from "../HSAxios";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import PaymentStatusModal from "./PaymentStatusModal";
import MapComponent from "./MapComponent";
import { 
  FaHome, 
  FaUtensils, 
  FaWifi, 
  FaBroom, 
  FaVenusMars, 
  FaTint, 
  FaDumbbell,
  FaSnowflake,
  FaShower,
  FaBed,
  FaBath,
  FaRupeeSign,
  FaMapMarkerAlt,
  FaArrowLeft,
  FaArrowRight,
  FaCheck
} from "react-icons/fa";

const steps = ["Details", "Location", "Price"];

export default function Update() {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState(0);
  const [errors, setErrors] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const [position, setPosition] = useState({
    lat: 28.7383,
    lng: 77.0822,
  });

  const [msg, setMsg] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [title, setTitle] = useState("");
  const [btnTitle, setBtnTitle] = useState(null);
  const [show, setShow] = useState(false);

  const [updHostel, setUpHostel] = useState({});
  const [loading, setLoading] = useState(true);
  let roomType;
  if (updHostel.room_type) {
    roomType = updHostel.room_type.split(",");
    console.log("room type is in array", roomType);
  }

  useEffect(() => {
    console.log("hostelid ", location.state.hostelId);
    HSAxios.get(`api/owner/hostel?hostel_id=${location.state.hostelId}`).then(
      (response) => {
        console.log(response);
        const allHostels = response.data[0];
        console.log(allHostels);
        setUpHostel(allHostels);
        // setUpHostel((prev) => ({
        //   ...prev,
        //   lat: position.lat,
        //   long: position.lng,
        // }));
        if (allHostels.lat != null && allHostels.long != null) {
          setPosition({
            lat: allHostels.lat,
            lng: allHostels.long,
          });
        }

        setLoading(false);
        console.log(updHostel);
      }
    );
  }, []);

  const validateFields = () => {
    const validationErrors = {};
    if (currentStep === 0) {
      if (!updHostel.name) validationErrors.name = "Name is required!";
      if (!updHostel.address) validationErrors.address = "Address is required!";
      if (!updHostel.pincode) validationErrors.pincode = "Pincode is required!";
      if (!updHostel.gender) validationErrors.gender = "Gender is required!";
      if (!updHostel.room_type)
        validationErrors.room_type = "Room type is required";
      if (!updHostel.food) validationErrors.food = "Food is required!";
      if (!updHostel.wifi) validationErrors.wifi = "Wifi is required!";
      if (!updHostel.housekeeping)
        validationErrors.housekeeping = "House Keeping is required!";
      if (!updHostel.purified_water)
        validationErrors.purified_water = "Purified Water is required!";
      if (!updHostel.workout_zone)
        validationErrors.workout_zone = "Workout Zone is required!";
      if (!updHostel.refrigerator)
        validationErrors.refrigerator = "Referigerator is required!";
      if (!updHostel.hot_water_supply)
        validationErrors.hot_water_supply = "Hot water supply is required!";

      if (!updHostel.washroom)
        validationErrors.washroom = "Washroom is required!";
    } else if (currentStep === 2) {
      if (!updHostel.starting_price || updHostel.starting_price <= 0) {
        validationErrors.starting_price =
          "Starting price must be greater than 0!";
      }
      if (!updHostel.unit) validationErrors.unit = "Unit is required!";
    }

    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const setFilter = (key, value) => {
    setUpHostel((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleRoomType = (value, isChecked) => {
    let roomTypeArray = updHostel.room_type
      ? updHostel.room_type.split(",")
      : [];

    if (isChecked) {
      if (!roomTypeArray.includes(value)) {
        roomTypeArray.push(value);
      }
    } else {
      roomTypeArray = roomTypeArray.filter((type) => type !== value);
    }

    setFilter("room_type", roomTypeArray.join(","));
  };

  const handleUpdateSubmit = (event) => {
    event.preventDefault();
    setBtnLoading(true);

    let loginUrl = "api/hostel/update";

    console.log(updHostel);
    console.log(validateFields());
    if (validateFields()) {
      const updatedHostel = {
        ...updHostel,
        lat: position.lat,
        long: position.lng,
      };
      HSAxios.put(loginUrl, updatedHostel)
        .then((res) => {
          if (res.status === 200) {
            console.log(res);
            console.log("data successfully updated");
            setMsg("Updated successfully! Redirecting to Hostel List page...");
            setTitle("Update Hostel Info");
            setShow(true);
            setIsSuccess(true);
            setTimeout(() => navigate("/hostel/list"), 3000);
          }
        })
        .catch((e) => {
          setMsg("Error occurred while updating hostel data!");
          setIsSuccess(false);
          setTitle("Error");
          console.error(e);
        })
        .finally(() => setBtnLoading(false));
    }
  };
  const handleNext = () => {
    if (validateFields()) {
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };
  const handleBack = () => {
    setCurrentStep((prev) => {
      return currentStep - 1;
    });
  };

  // Helper function to render toggle-style radio buttons
  const renderToggleButtons = (name, value, setValue, options, icon = null) => {
    return (
      <Form.Group className="mb-4">
        <Form.Label className="fw-semibold d-flex align-items-center gap-2 mb-3" style={{ fontSize: "16px", color: "#333" }}>
          {icon && <span style={{ color: "#760B0B" }}>{icon}</span>}
          {name}
        </Form.Label>
        <div className="d-flex gap-3 flex-wrap">
          {options.map((option, index) => (
            <label
              key={index}
              style={{
                flex: options.length === 2 ? "1" : "0 1 auto",
                minWidth: options.length > 2 ? "120px" : "auto",
                padding: "14px 20px",
                borderRadius: "12px",
                border: "2px solid #e0e0e0",
                cursor: "pointer",
                transition: "all 0.3s ease",
                backgroundColor: value === option.value ? "#fff5f5" : "white",
                borderColor: value === option.value ? "#760B0B" : "#e0e0e0",
                fontWeight: value === option.value ? "600" : "500",
                color: value === option.value ? "#760B0B" : "#666",
                textAlign: "center",
              }}
              onMouseEnter={(e) => {
                if (value !== option.value) {
                  e.target.style.borderColor = "#760B0B";
                  e.target.style.backgroundColor = "#fff5f5";
                }
              }}
              onMouseLeave={(e) => {
                if (value !== option.value) {
                  e.target.style.borderColor = "#e0e0e0";
                  e.target.style.backgroundColor = "white";
                }
              }}
            >
              <Form.Check
                inline
                label={option.label}
                type="radio"
                id={`${name}-${index}`}
                name={name}
                value={option.value}
                checked={value === option.value}
                onChange={() => setValue(option.value)}
                style={{ display: "none" }}
              />
              <span>{option.label}</span>
            </label>
          ))}
        </div>
      </Form.Group>
    );
  };

  return (
    <>
      {loading && (
        <div className="mt-5">
          {" "}
          <Spinner
            animation="border"
            role="status"
            className="text-primary mt-5 fw-bold"
          ></Spinner>
          <br></br>
          <span className="text-black">Please wait, Loading...</span>
        </div>
      )}
      {!loading && (
        <Container style={{ padding: "40px 20px", minHeight: "calc(100vh - 200px)" }}>
          <PaymentStatusModal
            msg={msg}
            show={show}
            isSuccess={isSuccess}
            onClose={() => setShow(false)}
            title={title}
            btnTitle={btnTitle}
          />
          
          <div className="text-center mb-5">
            <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "16px",
                  background: "linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "2px solid #760B0B",
                  boxShadow: "0 4px 12px rgba(118, 11, 11, 0.15)",
                }}
              >
                <FaHome style={{ fontSize: "28px", color: "#760B0B" }} />
              </div>
              <h2
                className="fw-bold mb-0"
                style={{
                  color: "#760B0B",
                  fontSize: "36px",
                  letterSpacing: "1.5px",
                  textShadow: "0 2px 4px rgba(118, 11, 11, 0.1)",
                }}
              >
                HOSTEL UPDATE
              </h2>
            </div>
            <p className="text-muted" style={{ fontSize: "16px" }}>
              Update your hostel details step by step
            </p>
          </div>

          {/* Modern Tab Navigation */}
          <Card
            style={{
              borderRadius: "20px",
              border: "2px solid #f0f0f0",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
              padding: "0",
              marginBottom: "30px",
              overflow: "hidden",
            }}
          >
            <div className="d-flex" style={{ backgroundColor: "#f8f9fa" }}>
              {steps.map((step, i) => {
                const isActive = currentStep === i;
                const isCompleted = currentStep > i;
                return (
                  <div
                    key={i}
                    onClick={() => {
                      if (currentStep > i || isActive) {
                        setCurrentStep(i);
                      }
                    }}
                    style={{
                      flex: 1,
                      padding: "20px 30px",
                      cursor: currentStep >= i ? "pointer" : "not-allowed",
                      backgroundColor: isActive ? "white" : "#f8f9fa",
                      borderBottom: isActive
                        ? "4px solid #10B981"
                        : isCompleted
                        ? "4px solid #10B981"
                        : "4px solid transparent",
                      transition: "all 0.3s ease",
                      textAlign: "center",
                      position: "relative",
                    }}
                    onMouseEnter={(e) => {
                      if (currentStep >= i) {
                        e.currentTarget.style.backgroundColor = isActive ? "white" : "#f0f0f0";
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = isActive ? "white" : "#f8f9fa";
                    }}
                  >
                    <div className="d-flex align-items-center justify-content-center gap-2">
                      {isCompleted && (
                        <FaCheck
                          style={{
                            color: "#10B981",
                            fontSize: "18px",
                          }}
                        />
                      )}
                      <span
                        style={{
                          fontWeight: isActive ? "700" : "600",
                          fontSize: "16px",
                          color: isActive
                            ? "#333"
                            : isCompleted
                            ? "#10B981"
                            : "#999",
                        }}
                      >
                        {step}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </Card>

          <Form className="text-start" onSubmit={handleUpdateSubmit}>
            {currentStep === 0 && (
              <Card
                style={{
                  borderRadius: "20px",
                  border: "2px solid #f0f0f0",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                  padding: "40px",
                }}
              >
                {renderToggleButtons(
                  "Food",
                  updHostel.food || "",
                  (value) => setFilter("food", value),
                  [
                    { label: "Vegetarian", value: "VEG" },
                    { label: "Non Vegetarian", value: "NON VEG" },
                  ],
                  <FaUtensils />
                )}

                {renderToggleButtons(
                  "Wifi",
                  updHostel.wifi || "",
                  (value) => setFilter("wifi", value),
                  [
                    { label: "Available", value: "AVAILABLE" },
                    { label: "Not Available", value: "NOT AVAILABLE" },
                  ],
                  <FaWifi />
                )}

                {renderToggleButtons(
                  "House Keeping",
                  updHostel.housekeeping || "",
                  (value) => setFilter("housekeeping", value),
                  [
                    { label: "Available", value: "AVAILABLE" },
                    { label: "Not Available", value: "NOT AVAILABLE" },
                  ],
                  <FaBroom />
                )}

                {renderToggleButtons(
                  "Gender",
                  updHostel.gender || "",
                  (value) => setFilter("gender", value),
                  [
                    { label: "Male", value: "MALE" },
                    { label: "Female", value: "FEMALE" },
                    { label: "Unisex", value: "UNISEX" },
                  ],
                  <FaVenusMars />
                )}

                {renderToggleButtons(
                  "Purified Water",
                  updHostel.purified_water || "",
                  (value) => setFilter("purified_water", value),
                  [
                    { label: "Available", value: "AVAILABLE" },
                    { label: "Not Available", value: "NOT AVAILABLE" },
                  ],
                  <FaTint />
                )}

                {renderToggleButtons(
                  "Workout Zone",
                  updHostel.workout_zone || "",
                  (value) => setFilter("workout_zone", value),
                  [
                    { label: "Available", value: "AVAILABLE" },
                    { label: "Not Available", value: "NOT AVAILABLE" },
                  ],
                  <FaDumbbell />
                )}

                {renderToggleButtons(
                  "Refrigerator",
                  updHostel.refrigerator || "",
                  (value) => setFilter("refrigerator", value),
                  [
                    { label: "Available", value: "AVAILABLE" },
                    { label: "Not Available", value: "NOT AVAILABLE" },
                  ],
                  <FaSnowflake />
                )}
                {errors.refrigerator && (
                  <p className="text-danger mb-3">{errors.refrigerator}</p>
                )}

                {renderToggleButtons(
                  "Hot Water Supply",
                  updHostel.hot_water_supply || "",
                  (value) => setFilter("hot_water_supply", value),
                  [
                    { label: "Available", value: "AVAILABLE" },
                    { label: "Not Available", value: "NOT AVAILABLE" },
                  ],
                  <FaShower />
                )}
                {errors.hot_water_supply && (
                  <p className="text-danger mb-3">{errors.hot_water_supply}</p>
                )}

                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold d-flex align-items-center gap-2 mb-3" style={{ fontSize: "16px", color: "#333" }}>
                    <FaBed style={{ color: "#760B0B" }} />
                    Room Type
                  </Form.Label>
                  <div className="d-flex gap-3 flex-wrap">
                    {[
                      { label: "Single", value: "SINGLE_BED" },
                      { label: "Double", value: "DOUBLE_BED" },
                      { label: "Triple", value: "TRIPLE_BED" },
                    ].map((option, index) => {
                      const isChecked = updHostel.room_type
                        ? updHostel.room_type.split(",").includes(option.value)
                        : false;
                      return (
                        <label
                          key={index}
                          style={{
                            flex: "0 1 auto",
                            minWidth: "120px",
                            padding: "14px 20px",
                            borderRadius: "12px",
                            border: "2px solid #e0e0e0",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            backgroundColor: isChecked ? "#fff5f5" : "white",
                            borderColor: isChecked ? "#760B0B" : "#e0e0e0",
                            fontWeight: isChecked ? "600" : "500",
                            color: isChecked ? "#760B0B" : "#666",
                            textAlign: "center",
                          }}
                          onMouseEnter={(e) => {
                            if (!isChecked) {
                              e.target.style.borderColor = "#760B0B";
                              e.target.style.backgroundColor = "#fff5f5";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!isChecked) {
                              e.target.style.borderColor = "#e0e0e0";
                              e.target.style.backgroundColor = "white";
                            }
                          }}
                        >
                          <Form.Check
                            inline
                            label={option.label}
                            type="checkbox"
                            id={`room-${index}`}
                            name="roomType"
                            value={option.value}
                            checked={isChecked}
                            onChange={(event) =>
                              handleRoomType(event.target.value, event.target.checked)
                            }
                            style={{ display: "none" }}
                          />
                          <span>{option.label}</span>
                        </label>
                      );
                    })}
                  </div>
                  {errors.room_type && (
                    <p className="text-danger mb-3">{errors.room_type}</p>
                  )}
                </Form.Group>

                {renderToggleButtons(
                  "Washroom",
                  updHostel.washroom || "",
                  (value) => setFilter("washroom", value),
                  [
                    { label: "Attached Washroom", value: "ATTACHED" },
                    { label: "Common Washroom", value: "COMMON" },
                  ],
                  <FaBath />
                )}
                <div className="d-flex justify-content-end mt-4">
                  <Button
                    onClick={handleNext}
                    type="button"
                    className="fw-semibold px-5 py-2"
                    style={{
                      backgroundColor: "#10B981",
                      borderColor: "#10B981",
                      borderRadius: "12px",
                      fontSize: "16px",
                      transition: "all 0.3s ease",
                      boxShadow: "0 4px 15px rgba(16, 185, 129, 0.3)",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#059669";
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow = "0 6px 20px rgba(16, 185, 129, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#10B981";
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "0 4px 15px rgba(16, 185, 129, 0.3)";
                    }}
                  >
                    Next <FaArrowRight className="ms-2" />
                  </Button>
                </div>
              </Card>
            )}
            {currentStep === 1 && (
              <>
                <Card
                  style={{
                    borderRadius: "20px",
                    border: "2px solid #f0f0f0",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                    padding: "40px",
                  }}
                >
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label className="fw-semibold d-flex align-items-center gap-2 mb-3" style={{ fontSize: "16px", color: "#333" }}>
                      <FaMapMarkerAlt style={{ color: "#760B0B" }} />
                      Select Location on Map
                    </Form.Label>
                    <MapComponent
                      setPosition={setPosition}
                      position={position}
                    />
                    <div className="d-flex justify-content-between mt-4">
                      <Button
                        onClick={handleBack}
                        type="button"
                        variant="outline-secondary"
                        className="fw-semibold px-5 py-2"
                        style={{
                          borderRadius: "12px",
                          border: "2px solid #e0e0e0",
                        }}
                      >
                        <FaArrowLeft className="me-2" />
                        Back
                      </Button>
                      <Button
                        onClick={handleNext}
                        type="button"
                        className="fw-semibold px-5 py-2"
                        style={{
                          backgroundColor: "#10B981",
                          borderColor: "#10B981",
                          borderRadius: "12px",
                          fontSize: "16px",
                          transition: "all 0.3s ease",
                          boxShadow: "0 4px 15px rgba(16, 185, 129, 0.3)",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = "#059669";
                          e.target.style.transform = "translateY(-2px)";
                          e.target.style.boxShadow = "0 6px 20px rgba(16, 185, 129, 0.4)";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "#10B981";
                          e.target.style.transform = "translateY(0)";
                          e.target.style.boxShadow = "0 4px 15px rgba(16, 185, 129, 0.3)";
                        }}
                      >
                        Next <FaArrowRight className="ms-2" />
                      </Button>
                    </div>
                  </Form.Group>
                </Card>
              </>
            )}
            {currentStep === 2 && (
              <Card
                style={{
                  borderRadius: "20px",
                  border: "2px solid #f0f0f0",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                  padding: "40px",
                }}
              >
                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold d-flex align-items-center gap-2 mb-2" style={{ fontSize: "16px", color: "#333" }}>
                    <FaRupeeSign style={{ color: "#760B0B" }} />
                    Starting Price
                  </Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter starting price"
                    value={updHostel.starting_price || ""}
                    onChange={(event) =>
                      setFilter("starting_price", event.target.value)
                    }
                    style={{
                      borderRadius: "12px",
                      padding: "12px 16px",
                      border: "2px solid #e0e0e0",
                      fontSize: "15px",
                      transition: "all 0.3s ease",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#760B0B";
                      e.target.style.boxShadow = "0 0 0 3px rgba(118, 11, 11, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#e0e0e0";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                  {errors.starting_price && (
                    <p className="text-danger mt-2">{errors.starting_price}</p>
                  )}
                </Form.Group>

                {renderToggleButtons(
                  "Unit",
                  updHostel.unit || "",
                  (value) => setFilter("unit", value),
                  [
                    { label: "Available", value: "AVAILABLE" },
                    { label: "Filled", value: "FILLED" },
                  ],
                  null
                )}
                <div className="d-flex justify-content-between mt-4">
                  <Button
                    onClick={handleBack}
                    type="button"
                    variant="outline-secondary"
                    className="fw-semibold px-5 py-2"
                    style={{
                      borderRadius: "12px",
                      border: "2px solid #e0e0e0",
                    }}
                  >
                    <FaArrowLeft className="me-2" />
                    Back
                  </Button>
                  <Button
                    type="submit"
                    disabled={btnLoading}
                    className="fw-semibold px-5 py-2"
                    style={{
                      backgroundColor: "#760B0B",
                      borderColor: "#760B0B",
                      borderRadius: "12px",
                      fontSize: "16px",
                      transition: "all 0.3s ease",
                      boxShadow: "0 4px 15px rgba(118, 11, 11, 0.3)",
                    }}
                    onMouseEnter={(e) => {
                      if (!btnLoading) {
                        e.target.style.backgroundColor = "#8B0000";
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow = "0 6px 20px rgba(118, 11, 11, 0.4)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!btnLoading) {
                        e.target.style.backgroundColor = "#760B0B";
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = "0 4px 15px rgba(118, 11, 11, 0.3)";
                      }
                    }}
                  >
                    {btnLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" />
                        Submitting...
                      </>
                    ) : (
                      <>
                        <FaCheck className="me-2" />
                        Submit
                      </>
                    )}
                  </Button>
                </div>
              </Card>
            )}
          </Form>
        </Container>
      )}
    </>
  );
}
